import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var partnerOverViewUrlConfig = {
    profDemoMapNomSegDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/PartnerDetails",
    bank: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/PartnerBank",
    registrationDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/PartnerRegistration",
    certificationDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/PartnerCertification",
    partnerSearch: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/PartnerSearch",
    partnerClientsSummary: URLConfig.config.apiBase +
        microService.userService +
        "partner/PartnerClientSummary",
    partnerRevenueSummary: URLConfig.config.apiBase +
        microService.dashboardService +
        "partner/NrYearData",
};
export default partnerOverViewUrlConfig;
